// GET /v1/api/feature-flags
export type FeatureFlagsDTO = Record<string, boolean>;

/** Enables the bank check payout type, per firm (an AppConfig flag with a `firmIds` allowlist). */
export const CHECK_PAYOUTS_FLAG = 'check_payouts';

/** Present (and `true`) instead of individual flags when the server is forcing every flag on — e.g. local dev with no AppConfig connection. */
export const FORCE_ALL_FLAGS_SENTINEL = '__force_all__';
